import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  label {
    margin-bottom: 40px;
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.darkerblue};
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  background: ${(props) => props.theme.colors.disabled};
  border-radius: 10px;
  margin-left: auto;
  font-size: 12px;
  color: ${(props) => props.theme.colors.label};
  font-weight: 700;
  cursor: pointer;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 47px;
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  font-weight: 600;
  font-size: 20px;
  background: ${(props) => props.theme.colors.lightblue};
  cursor: pointer;
  transition: background-color 0.3s;
  
  :hover {
    /* background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.lightblue}; */
  }
`;

export const CancelButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 47px;
  color: ${(props) => props.theme.colors.white};
  text-transform: uppercase;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.label};
  font-weight: 600;
  font-size: 20px;
  background: ${(props) => props.theme.colors.label};
  cursor: pointer;
  transition: background-color 0.3s;

  :hover {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.label};
  }
`;

export const modalStyle = {
  overlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 5,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "550px",
    height: "280px",
    borderRadius: "16px",
    padding: 0,
    transform: "translate(-50%, -50%)",
  },
};
